import { DndContext, DragEndEvent, DragOverlay } from '@dnd-kit/core';
import { observer } from 'mobx-react';
import { DispatchingRulesBranchesList } from './containers/DispatchingRulesBranchesList/DispatchingRulesBranchesList';
import { DispatchingRulesProfilesList } from './containers/DispatchingRulesProfilesList/DispatchingRulesProfilesList';
import { DspList } from './containers/DspList/DspList';
import { dispatchingRulesStore } from './stores/dispatchingRulesStore';
import { dndAutoScrollOptionsDefault, dndOverlayAnimationDefault, DndSensors } from 'src/utils/dnd';
import LoadingOverlay from 'src/view/components/LoadingOverlay/LoadingOverlay';
import Portal from 'src/view/components/Portal/Portal';
import { ProfileBranch } from '~/view/containers/ProfileBranches/components/ProfileBranch/ProfileBranch';

export const DispatchingRulesScreen = observer(() => {
  const handleDragEnd = ({ active, over }: DragEndEvent) => {
    if (over && dispatchingRulesStore.selectedProfile?.id !== Number(over.id)) {
      dispatchingRulesStore.movingBranches([], { branchId: Number(active.id), profileId: Number(over.id) });
    }
    dispatchingRulesStore.setSelectedBranch(null);
  };

  return (
    <div className="pos-relative d-flex flex-row flex-grow-1 pr-4">
      <div className="d-flex flex-row">
        <DndContext
          id="branches"
          autoScroll={dndAutoScrollOptionsDefault}
          sensors={DndSensors()}
          onDragStart={({ active }) => dispatchingRulesStore.setSelectedBranch(Number(active.id))}
          onDragCancel={() => dispatchingRulesStore.setSelectedBranch(null)}
          onDragEnd={handleDragEnd}
        >
          <DispatchingRulesProfilesList />
          <DispatchingRulesBranchesList />

          <Portal>
            <DragOverlay dropAnimation={dndOverlayAnimationDefault}>
              {dispatchingRulesStore.selectedBranch ? (
                <ProfileBranch
                  branch={dispatchingRulesStore.selectedBranch}
                  availableDragAndDrop
                  isOverlayBranch
                  className="profile-branch__drag_active"
                />
              ) : null}
            </DragOverlay>
          </Portal>
        </DndContext>
      </div>

      <DspList />
      <LoadingOverlay visible={dispatchingRulesStore.loading} refreshing={dispatchingRulesStore.profiles.length > 0} />
    </div>
  );
});
